module.exports = __webpack_public_path__ + "img/img1.e703dde1.png";